/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ deltaText: NonNullable<unknown>, day: NonNullable<unknown> }} Progress_Body_Weight_ChangeInputs */

const en_us2_progress_body_weight_change = /** @type {(inputs: Progress_Body_Weight_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} since ${i?.day}`)
};

const pt_br2_progress_body_weight_change = /** @type {(inputs: Progress_Body_Weight_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} desde ${i?.day}`)
};

const es_419_progress_body_weight_change = /** @type {(inputs: Progress_Body_Weight_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} desde el ${i?.day}`)
};

const pt_pt2_progress_body_weight_change = /** @type {(inputs: Progress_Body_Weight_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} desde ${i?.day}`)
};

const fr_fr2_progress_body_weight_change = /** @type {(inputs: Progress_Body_Weight_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} depuis le ${i?.day}`)
};

const de_de2_progress_body_weight_change = /** @type {(inputs: Progress_Body_Weight_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} seit ${i?.day}`)
};

const it_it2_progress_body_weight_change = /** @type {(inputs: Progress_Body_Weight_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.deltaText} dal ${i?.day}`)
};

/**
* | output |
* | --- |
* | "{deltaText} since {day}" |
*
* @param {Progress_Body_Weight_ChangeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_body_weight_change = /** @type {((inputs: Progress_Body_Weight_ChangeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Body_Weight_ChangeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_body_weight_change(inputs)
	if (locale === "es-419") return es_419_progress_body_weight_change(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_body_weight_change(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_body_weight_change(inputs)
	if (locale === "de-DE") return de_de2_progress_body_weight_change(inputs)
	if (locale === "it-IT") return it_it2_progress_body_weight_change(inputs)
	return en_us2_progress_body_weight_change(inputs)
});
export { progress_body_weight_change as "progress.body_weight_change" }